import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

export const ITFLSSteppersMap = {
    paymentsIn: "Payments in",
    adviserCharges: "Adviser charges",
    investment: "Investment selection",
    review: "Review",
    doc: "Documents/Declaration",
    comfirm: "Confirmation",
    incomePayment: "Income payment details",
    drawdown: "Drawdown details"
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.Npr]: "Aberdeen SIPP",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Wrap Cash",
};

export const FinancialAdviceMap = {
    true: "Yes",
    false: "No",
};

export const DocumentsAndDeclarationContent = {
    header: "Documents",
    clientDeclaration: {
        header: "Client Declaration",
        label: "Please have your client complete the following document then upload a completed copy",
        uploadLabel: (firstname: string, lastname: string) => `${firstname} ${lastname} declaration to proceed`,
        uploadInstruction: "Upload completed client declaration",
        successfullyUploaded: "Client declaration uploaded successfully",
    },
    documentsToPost: {
        header: "Documents to post"
    },
    documentsAvailable: {
        header: "Documents available",
        label: "All documents have been collated into a single bundle which you can download or email"
    },
    declarations: {
        header: "Declarations",
        authorityToProceed: "I have the authority to proceed from the client.",
        checkedAddress: "I have checked the client's address on Wrap and confirm it's their personal home address",
        confirmList: "I confirm that:",
        firstConfirm: " I have informed my client about the tax relief that is available on contributions and the limits that apply.",
        secondConfirm: " I have informed my client about the cancellation rights (if any) apply that apply to this pension benefit payment.",
        thirdConfirm: " I have provided my client with all pre-sale information required under applicable laws and regulations, including (where applicable) the relevant",
        thirdConfirmPointOne: " KFDs and KFIs;",
        thirdConfirmPointTwo: " KIDs, KIIDs and charges information documents (as applicable); and",
        thirdConfirmPointThree: " SDR and investment label information documents (as applicable)",
        thirdConfirmConclusion: " and that my client has had a reasonable opportunity to read these.",
        fourConfirm: "All documentation submitted by me will include the account number allocated to this application",
        explainedDataProtection: "I will ensure that my client will meet the eligibility criteria of any investment held in their account as described in the relevant investment documentation.",
        investmentPathway: " I can confirm that the client has been presented with all relevant investment pathway information as this is not a personal recommendation",
        confirmAll: "Confirm all"
    },
    validation: {
        mustAcceptAll: "You must accept all items to continue",
        uploadDeclaration: "You must upload client declaration to continue"
    }
};
